module.exports = __webpack_public_path__ + "media/images/icons/country_flags/aw-6c82c52fc38525a1a69eaf9e5e03f853.svg";